"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnotationTextEditor = void 0;
const UiElements_1 = require("../modules/ui/UiElements");
const Language_1 = require("../modules/language/Language");
const ViewerOptions_1 = require("../objects/ViewerOptions");
const utils_1 = require("../utils/utils");
class AnnotationTextEditor {
    constructor(annotationService, apiService, formEl) {
        this.annotationService = annotationService;
        this.apiService = apiService;
        this.formEl = formEl;
        this.language = new Language_1.Language(ViewerOptions_1.ViewerOptions.language);
        PubSub.subscribe("show-annotation-in-menu" /* ANNOTATION_SHOW_MENU */, (_, annotation) => this.openAnnotationMenuWithId(annotation));
    }
    openAnnotationMenuWithId(annotation) {
        const annContainerEl = this.formEl.domEl.querySelector('.annCard[data-ann-id="' + annotation.manualId + '"]');
        annContainerEl.click();
    }
    createAnnotation(annotation) {
        const annContainer = new UiElements_1.DivEl().setClass('annCard');
        const buttons = createButtons();
        const fileInputEl = createHiddenFileInputEl();
        const headerEl = createAnnotationHeaderEl();
        const imageElContainer = createImageContainerEl();
        const contentEl = createAnnotationContentEl();
        annContainer.domEl.append(headerEl, contentEl);
        this.formEl.domEl.appendChild(annContainer.domEl);
        registerAnnotationElExpandEvent();
        registerAnnotationDeleteEvent();
        registerUploadButtonEvent();
        registerFileInputChangeEvent();
        registerImageRemoveEvent();
        registerDragStartEvent();
        registerDragOverEvent();
        registerOnDragEndEvent(this.annotationService);
        this.language.updateTranslatableElements();
        function createButtons() {
            const btns = {
                options: {
                    image: createButton('image', 'UPLOAD_IMAGE', 'image'),
                    edit: createButton('edit', 'EDIT', 'edit'),
                    delete: createButton('delete', 'DELETE_ANNOTATION', 'delete'),
                    drag: setAsDraggable(createButton('drag', 'DRAG', 'drag')),
                },
                image: {
                    remove: createButton('right-bound', 'REMOVE_IMAGE', 'close'),
                }
            };
            return btns;
            function createButton(classNames, title, iconName) {
                return new UiElements_1.ButtonEl()
                    .setClass(classNames)
                    .addAttribute('data-i18n-attr', `data-title=${title}`)
                    .addChild((new UiElements_1.IconEl(iconName)));
            }
            function setAsDraggable(btn) {
                btn.domEl.draggable = true;
                return btn;
            }
        }
        function createHiddenFileInputEl() {
            const el = document.createElement('input');
            el.type = 'file';
            el.id = 'annotationImageFile';
            el.setAttribute('hidden', '');
            return el;
        }
        function createAnnotationHeaderEl() {
            const headerEl = document.createElement('div');
            annContainer.addAttribute('data-ann-id', annotation.manualId);
            headerEl.className = 'annotationHeader';
            const orderNumberEl = new UiElements_1.SpanEl().setTextContent(annotation.orderNumber + '');
            const annNameEl = new UiElements_1.SpanEl().setClass('annName').setTextContent(annotation.name || '');
            const optionsEl = createOptionsEl();
            headerEl.append(orderNumberEl.domEl, annNameEl.domEl, optionsEl.domEl);
            function createOptionsEl() {
                return new UiElements_1.DivEl().setClass('options')
                    .addChild(buttons.options.image)
                    .addChild(buttons.options.edit)
                    .addChild(buttons.options.delete)
                    .addChild(buttons.options.drag);
            }
            return headerEl;
        }
        function createImageContainerEl() {
            const el = new UiElements_1.DivEl().setClass('imageContainer');
            if (annotation.loadingImage) {
                // Checking if image was fetched, so that blob url can be used to display image
                // This is not the great not terrible
                (0, utils_1.retry)(() => {
                    if (!annotation.loadingImage) {
                        addImageToAnnotationEl(el.domEl, annotation.imageBlobUrl || '', annotation.imageId);
                        return true;
                    }
                    return false;
                }, 200);
            }
            return el;
        }
        function createAnnotationContentEl() {
            // Used to determine contents (formEl) height
            const innerContainerEl = new UiElements_1.DivEl().setClass('content');
            //TODO: change for translation
            const nameInput = createNameInput();
            const textareaEl = createTextareaEl();
            innerContainerEl.domEl.append(nameInput, imageElContainer.domEl, textareaEl, fileInputEl);
            const contentEl = document.createElement('div');
            contentEl.className = 'annotationContent';
            contentEl.appendChild(innerContainerEl.domEl);
            return contentEl;
            function createNameInput() {
                const el = document.createElement('input');
                el.type = 'text';
                el.placeholder = 'Naslov';
                el.value = annotation.name || '';
                el.oninput = (ev) => {
                    ev.stopPropagation();
                    const annotationData = {
                        manualId: annotation.manualId,
                        orderNumber: annotation.orderNumber,
                        name: el.value,
                        content: annotation.content,
                    };
                    PubSub.publish("annotation-update" /* ANNOTATION_UPDATE */, annotationData);
                };
                return el;
            }
            function createTextareaEl() {
                const MIN_TEXTAREA_HEIGHT = 206;
                //TODO: change for translation
                const textareaEl = document.createElement('textarea');
                textareaEl.value = annotation.content || '';
                textareaEl.spellcheck = false;
                textareaEl.placeholder = 'Opis...';
                textareaEl.setAttribute('style', 'height:' + (textareaEl.scrollHeight || MIN_TEXTAREA_HEIGHT) + 'px;overflow-y:hidden;');
                textareaEl.oninput = () => onTextareaChange();
                function onTextareaChange() {
                    textareaEl.style.height = 'auto';
                    textareaEl.style.height = (textareaEl.scrollHeight > MIN_TEXTAREA_HEIGHT ? textareaEl.scrollHeight : MIN_TEXTAREA_HEIGHT) + 'px';
                    const annotationData = {
                        manualId: annotation.manualId,
                        orderNumber: annotation.orderNumber,
                        name: annotation.name,
                        content: textareaEl.value,
                    };
                    PubSub.publish("annotation-update" /* ANNOTATION_UPDATE */, annotationData);
                }
                return textareaEl;
            }
        }
        function registerAnnotationElExpandEvent() {
            annContainer.domEl.onclick = () => expandAnnotation();
            function expandAnnotation() {
                var _a;
                if (annContainer.domEl.classList.contains('active')) {
                    return;
                }
                // Hide the opened one
                const openedAnnEl = document.querySelector('.annCard.active');
                if (openedAnnEl) {
                    openedAnnEl.classList.remove('active');
                    const openedAnnContent = openedAnnEl.querySelector('.annotationContent');
                    openedAnnContent.style.height = ((_a = openedAnnContent.querySelector('.content')) === null || _a === void 0 ? void 0 : _a.clientHeight) + 'px';
                    openedAnnContent.style.overflow = 'hidden';
                    setTimeout(() => {
                        openedAnnContent.style.height = '';
                        openedAnnContent.style.paddingBottom = '';
                    }, 10);
                }
                const contentContainer = contentEl.querySelector('.content');
                annContainer.domEl.classList.add('active');
                contentEl.style.height = (((contentContainer === null || contentContainer === void 0 ? void 0 : contentContainer.clientHeight) || 0) + 10) + 'px';
                // After animation is complete, change height to auto so that element can expand
                // together with content.
                setTimeout(() => {
                    contentEl.style.height = 'auto';
                    contentEl.style.paddingBottom = '10px';
                    contentEl.style.overflow = 'visible';
                }, 300);
                PubSub.publish("annotation-goto" /* ANNOTATION_GOTO */, annotation);
            }
        }
        function registerAnnotationDeleteEvent() {
            buttons.options.delete.domEl.onclick = () => removeAnnotation();
            function removeAnnotation() {
                annContainer.domEl.remove();
                redrawNumbers();
                PubSub.publish("annotation-remove" /* ANNOTATION_REMOVE */, annotation.manualId);
            }
        }
        function registerUploadButtonEvent() {
            buttons.options.image.domEl.onclick = (e) => {
                e.preventDefault();
                e.stopImmediatePropagation();
                fileInputEl.click();
            };
        }
        function registerFileInputChangeEvent() {
            fileInputEl.onchange = (e) => handleFileUpload(e);
            function handleFileUpload(e) {
                var _a;
                e.preventDefault();
                const file = (_a = fileInputEl.files) === null || _a === void 0 ? void 0 : _a[0];
                if (!file) {
                    return;
                }
                annotation.addImageAsFile(file);
                addImageToAnnotationEl(imageElContainer.domEl, annotation.imageBlobUrl || '', annotation.imageId);
            }
        }
        function addImageToAnnotationEl(parent, blobUrl, imageId) {
            const imageOptionsContainer = new UiElements_1.DivEl().setClass('options');
            imageOptionsContainer.addChild(buttons.image.remove);
            // Button for image upload must be hidden when annotation has image
            hideImageUploadButton();
            const imageEl = new UiElements_1.ImageEl(blobUrl || '').addAttribute('data-id', imageId).domEl;
            parent.append(imageEl, imageOptionsContainer.domEl);
        }
        function registerImageRemoveEvent() {
            buttons.image.remove.domEl.onclick = () => removeImage();
            function removeImage() {
                annotation.removeImage();
                imageElContainer.setInnerHTML('');
                buttons.image.remove.domEl.remove();
                showImageUploadButton();
            }
        }
        function hideImageUploadButton() {
            buttons.options.image.domEl.classList.add('hidden');
        }
        function showImageUploadButton() {
            buttons.options.image.domEl.classList.remove('hidden');
        }
        function registerDragStartEvent() {
            annContainer.domEl.ondragstart = (e) => onAnnCardDrag(e);
            function onAnnCardDrag(ev) {
                var _a;
                annContainer.domEl.classList.add('dragged');
                (_a = ev.dataTransfer) === null || _a === void 0 ? void 0 : _a.setDragImage(annContainer.domEl, 200, 40);
            }
        }
        function registerDragOverEvent() {
            annContainer.domEl.ondragover = (ev) => dragOverEvent(ev);
            function dragOverEvent(ev) {
                var _a, _b, _c;
                // Check if image is being dragged
                if ((_a = ev.dataTransfer) === null || _a === void 0 ? void 0 : _a.items.length) {
                    return;
                }
                const afterElement = getElementAfterMousePosition(ev.clientY);
                const draggedEl = document.querySelector('.annCard.dragged');
                if (!draggedEl) {
                    return;
                }
                if (afterElement) {
                    (_b = document.querySelector('.annotationForm')) === null || _b === void 0 ? void 0 : _b.insertBefore(draggedEl, afterElement);
                }
                else {
                    (_c = document.querySelector('.annotationForm')) === null || _c === void 0 ? void 0 : _c.appendChild(draggedEl);
                }
            }
        }
        function getElementAfterMousePosition(mouseY) {
            let draggableElementsAll = Array.from(document.getElementsByClassName('annCard'));
            let draggableElements = [];
            for (let i = 0; i < draggableElementsAll.length; i++) {
                if (!draggableElementsAll[i].classList.contains('dragged')) {
                    draggableElements.push(draggableElementsAll[i]);
                }
            }
            let closestElementDistance = Number.POSITIVE_INFINITY;
            let closestElement = null;
            for (let i = 0; i < draggableElements.length; i++) {
                let boundingBox = draggableElements[i].getBoundingClientRect();
                let distance = (boundingBox.height / 2 + boundingBox.top) - mouseY;
                if (distance > 0 && distance < closestElementDistance) {
                    closestElement = draggableElements[i];
                    closestElementDistance = distance;
                }
            }
            return closestElement;
        }
        function registerOnDragEndEvent(annotationService) {
            annContainer.domEl.parentElement.ondragend = (ev) => {
                const annotationEls = document.querySelectorAll('.annCard');
                const draggedAnnotationEl = document.querySelector('.annCard.dragged');
                if (!draggedAnnotationEl) {
                    return;
                }
                draggedAnnotationEl.classList.remove('dragged');
                //TODO: just add .orderNumber in annotationHeader
                const numberEl = draggedAnnotationEl.querySelector('.annotationHeader > span:first-child');
                const newIndex = Array.from(annotationEls).indexOf(draggedAnnotationEl);
                const prevIndex = Number(numberEl === null || numberEl === void 0 ? void 0 : numberEl.textContent) - 1 || 0;
                if (newIndex === prevIndex) {
                    return;
                }
                if (newIndex > prevIndex) { // annotation was moved down
                    annotationService.changeOrderNumber(prevIndex, newIndex, 'down');
                }
                else { // annotaion was moved up
                    annotationService.changeOrderNumber(prevIndex, newIndex, 'up');
                }
                redrawNumbers();
            };
        }
        function redrawNumbers() {
            const annCardEls = document.querySelectorAll('.annCard');
            const nOfAnnotationCards = annCardEls.length;
            for (let i = 0; i < nOfAnnotationCards; i++) {
                // We add +1 to i because annotations start with 1 and not 0
                annCardEls[i].querySelector('.annotationHeader > span:first-child').textContent = (i + 1) + '';
            }
        }
    }
}
exports.AnnotationTextEditor = AnnotationTextEditor;
